import { render, staticRenderFns } from "./contacts-detail-table-panel.vue?vue&type=template&id=46f5c452&scoped=true&lang=pug"
import script from "./contacts-detail-table-panel.vue?vue&type=script&lang=js"
export * from "./contacts-detail-table-panel.vue?vue&type=script&lang=js"
import style0 from "./contacts-detail-table-panel.vue?vue&type=style&index=0&id=46f5c452&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f5c452",
  null
  
)

export default component.exports